<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div class="flex-space-between" style="align-items: center">
      Upgrade to add your own knowledge base for AI-generated responses
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
        [queryParams]="{ plan: 'pro' }"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <ion-segment mode="md">
    <ion-segment-button
      value="/dashboard/knowledge/articles"
      routerLink="/dashboard/knowledge/articles"
      routerLinkActive="segment-button-checked"
    >
      <ion-label>Articles</ion-label>
    </ion-segment-button>
    <ion-segment-button
      value="/dashboard/knowledge/sources"
      routerLink="/dashboard/knowledge/sources"
      routerLinkActive="segment-button-checked"
    >
      <ion-label>Sources</ion-label>
    </ion-segment-button>
    <ion-segment-button
      value="/dashboard/knowledge/suggestions"
      routerLink="/dashboard/knowledge/suggestions"
      routerLinkActive="segment-button-checked"
    >
      <ion-label>Suggestions</ion-label>
    </ion-segment-button>
    <ion-segment-button
      *ngIf="knowledgeGapAnalysisEnabled"
      value="/dashboard/knowledge/insights"
      routerLink="/dashboard/knowledge/insights"
      routerLinkActive="segment-button-checked"
    >
      <ion-label>Insights</ion-label>
    </ion-segment-button>
  </ion-segment>

  <router-outlet></router-outlet>
</ion-content>
